import i18n from '../../i18n'
import {
  CHANGES_FROM_260101,
  changesText260101,
  changesUhrada260101,
  removePayments260101
} from './DATA_PLATBY/changes260101'

const ctx = (require as any).context('./DATA_PLATBY', false, /\.json$/)

const paymentsData: Record<string, any> = Object.fromEntries(
  ctx.keys().map((k: string) => {
    const name = k.replace('./', '')
    const mod = ctx(k)
    return [name, mod.default ?? mod]
  })
)

enum FILES {
  indikacniSkupina = 'indikacniSkupina.json',
  refSkupiny = 'refSkupiny.json',
  oblast = 'oblast.json'
}

const getFile = (filename: string)=> {
  const file = paymentsData[filename]
  if (file && typeof file === 'object') return file
  console.error('Nelze nacist data z ', filename)
  return []
}

const applyChanges = (payments: any[], platbaPlatnost?: string) => {
  if (platbaPlatnost === CHANGES_FROM_260101) {

    return payments
      .filter((payment: any) => !removePayments260101.includes(payment.kod))
      .map((payment: any) => {
        const noveUhrada = changesUhrada260101[payment.kod]
        const noveTexty = changesText260101[payment.kod]
        if (!noveUhrada && !noveTexty) return payment
        return { ...payment, ...(noveTexty ?? {}), ...(noveUhrada ? { uhrada: noveUhrada } : {}) }
      })
  }

  return payments
}

export const getPayments = (oblastId: number, platbaPlatnost?: string) =>
  applyChanges(getFile(`platba${oblastId}.json`), platbaPlatnost)

export const getIndikacniSkupiny = () =>
  getFile(FILES.indikacniSkupina).map((item:any) => ({
    value: item.id,
    label: `${item.id} ${item.nazev}`
  }))

export const getRefSkupiny = () => getFile(FILES.refSkupiny)

export const getOblast = (id_oblasti: number) =>
  getFile(FILES.oblast).find((o: any) => Number(o.id_oblasti) === Number(id_oblasti)
  )

const EN_MAP: Record<string, string> = {
  nazevKategorie: 'nazevKategorieEn',
  podkategorie: 'podkategorieEn',
  popisNasobny: 'popisNasobnyEn',
  poznamkaNazvu: 'poznamkaNazvuEn',
  poznamkaUhrada: 'poznamkaUhradaEn',
  poznamkaPodkategorie: 'poznamkaPodkategorieEn'
}

export const translatePayment = (payment: any) => {
  if (i18n.language !== 'en') return payment
  const out = { ...payment }
  for (const [cz, en] of Object.entries(EN_MAP)) out[cz] = payment[en] ?? payment[cz]
  return out
}
